export const financialManagementConst = {
  path: "/single-programs/financial-management",
  title: "ФАКУЛЬТЕТ ЭКОНОМИКИ И УПРАВЛЕНИЯ – ФИНАНСОВЫЙ МЕНЕДЖМЕНТ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Финансовый менеджмент — язык бизнеса и основа роста</h2>
      <p>
        Эта программа объединяет ключевые аспекты управления корпоративными финансами, инвестиционной деятельностью и анализом рисков.
        Студенты осваивают инструменты, которые позволяют принимать стратегические решения в условиях быстро меняющейся экономики.
      </p>
      <p>
        Программа готовит специалистов, способных уверенно управлять финансовыми потоками, прогнозировать тенденции и повышать эффективность
        бизнеса.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Финансовый анализ и отчётность</li>
        <li>Корпоративные финансы и бюджетирование</li>
        <li>Управление инвестициями и оценка проектов</li>
        <li>Международные стандарты учёта (IFRS, GAAP)</li>
        <li>Банковское дело и денежно-кредитная система</li>
        <li>Управление финансовыми рисками и хеджирование</li>
        <li>Экономический анализ и моделирование</li>
        <li>Финансовые технологии и цифровая аналитика (Excel, BI-системы)</li>
      </ul>
      <p>
        Программа предполагает практические кейсы, финансовое моделирование и подготовку к сертификациям (CFA, ACCA — по выбору студента).
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Финансовый аналитик</li>
        <li>Риск-менеджер в компании или банке</li>
        <li>Бизнес-консультант по инвестициям</li>
        <li>Финансовый контролёр или менеджер бюджета</li>
        <li>Корпоративный финансовый консультант</li>
        <li>Будущий CFO (финансовый директор)</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€50,000 до €95,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Диплом европейского образца с высоким спросом на рынке</li>
        <li>Очная и дистанционная форма обучения</li>
        <li>Преподаватели — специалисты финансовой индустрии</li>
        <li>Практика в консалтинговых и инвестиционных структурах</li>
        <li>Возможность обучения на русском или английском</li>
        <li>Сопровождение от приёмной комиссии и карьерная поддержка</li>
      </ul>
      <p>Цифры говорят сами за себя — главное, уметь их читать и анализировать</p>
      <p>Наши выпускники становятся профессионалами, которых ценят в международных компаниях, банках и стартапах.</p>
      <br />
      <p className="padding-left">
        «Финансовый менеджмент — это контроль над рисками и уверенность в завтрашнем дне. Мы учим видеть и действовать на опережение.»
      </p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам пройти путь от выбора программы до зачисления без лишних сложностей.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Финансовый менеджмент — язык бизнеса и основа роста
    Эта программа объединяет ключевые аспекты управления корпоративными финансами, инвестиционной деятельностью и анализом рисков. Студенты осваивают инструменты, которые позволяют принимать стратегические решения в условиях быстро меняющейся экономики.
    Программа готовит специалистов, способных уверенно управлять финансовыми потоками, прогнозировать тенденции и повышать эффективность бизнеса.
    Что вы будете изучать?
    • Финансовый анализ и отчётность
    • Корпоративные финансы и бюджетирование
    • Управление инвестициями и оценка проектов
    • Международные стандарты учёта (IFRS, GAAP)
    • Банковское дело и денежно-кредитная система
    • Управление финансовыми рисками и хеджирование
    • Экономический анализ и моделирование
    • Финансовые технологии и цифровая аналитика (Excel, BI-системы)
    Программа предполагает практические кейсы, финансовое моделирование и подготовку к сертификациям (CFA, ACCA — по выбору студента).
    Кем можно работать после окончания?
    • Финансовый аналитик
    • Риск-менеджер в компании или банке
    • Бизнес-консультант по инвестициям
    • Финансовый контролёр или менеджер бюджета
    • Корпоративный финансовый консультант
    • Будущий CFO (финансовый директор)
    Зарплата в Европе: от €50,000 до €95,000 в год
    Почему выбирают нас?
    • Диплом европейского образца с высоким спросом на рынке
    • Очная и дистанционная форма обучения
    • Преподаватели — специалисты финансовой индустрии
    • Практика в консалтинговых и инвестиционных структурах
    • Возможность обучения на русском или английском
    • Сопровождение от приёмной комиссии и карьерная поддержка
    Цифры говорят сами за себя — главное, уметь их читать и анализировать
    Наши выпускники становятся профессионалами, которых ценят в международных компаниях, банках и стартапах.
    «Финансовый менеджмент — это контроль над рисками и уверенность в завтрашнем дне. Мы учим видеть и действовать на опережение.»
    Как поступить?
    Приёмная комиссия поможет вам пройти путь от выбора программы до зачисления без лишних сложностей.
  `,
};
